import React from "react";
import { Checkbox } from "primereact/checkbox";

export const CONTACT_PERMISSION_TYPES = ["Employee", "Professional", "Client"];

interface Props {
    selectedTypes: string[];
    onChange: (types: string[]) => void;
}

// This feature developed by Dinesh - grouped contact access selector.
const ContactPermissionSelector: React.FC<Props> = ({ selectedTypes, onChange }) => {
    const toggleType = (contactType: string) => {
        onChange(selectedTypes.includes(contactType)
            ? selectedTypes.filter((type) => type !== contactType)
            : [...selectedTypes, contactType]);
    };

    return (
        <div className="contact_permission_selector">
            <div className="contact_permission_intro">
                <i className="bi bi-shield-check"></i>
                <div>
                    <h6>Contact access</h6>
                    <p>Select which contact groups this employee can access.</p>
                </div>
            </div>
            <div className="contact_permission_groups">
                {CONTACT_PERMISSION_TYPES.map((contactType) => {
                    const checked = selectedTypes.includes(contactType);
                    return (
                        <label className={`contact_permission_group ${checked ? "selected" : ""}`} key={contactType}>
                            <span className="contact_permission_icon"><i className={`bi ${contactType === "Employee" ? "bi-people" : contactType === "Professional" ? "bi-briefcase" : "bi-person-vcard"}`}></i></span>
                            <span className="contact_permission_text"><strong>{contactType}</strong><small>Allow all {contactType.toLowerCase()} contacts</small></span>
                            <Checkbox inputId={`permission-${contactType}`} checked={checked} onChange={() => toggleType(contactType)} />
                        </label>
                    );
                })}
            </div>
        </div>
    );
};

export default ContactPermissionSelector;
